// extracted by mini-css-extract-plugin
module.exports =  {"side-drawer-button":"side-drawer-button-lVLKS","icon":"icon-g5Oo_"};